<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>费用看板</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">我的报销</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isShowDetails && !showIsAdd && !showIsEdit">
      <section class="searchBox">
        <span>
          <a-button v-show="!showIsSearch" @click="showIsSearch = true"
            >显示更多</a-button
          >
          <a-button v-show="showIsSearch" @click="showIsSearch = false"
            >隐藏更多</a-button
          >
        </span>
        <span class="addStyle">
          <a-button @click="showIsAdd = !showIsAdd" type="primary" icon="plus"
            >新增报销-管家工资</a-button
          >
        </span>
        <span>
          <label>状态：</label>
          <a-select style="width: 140px" v-model="status">
            <a-select-option :value="10">待项目经理审核</a-select-option>
            <a-select-option :value="11">项目经理驳回</a-select-option>
            <a-select-option :value="200">待项目总监审核</a-select-option>
            <a-select-option :value="210">项目总监驳回</a-select-option>
            <a-select-option :value="20">待项目负责人审核</a-select-option>
            <a-select-option :value="21">项目负责人驳回</a-select-option>
            <a-select-option :value="30">待财务审核</a-select-option>
            <a-select-option :value="31">财务驳回</a-select-option>
            <a-select-option :value="40">待打款</a-select-option>
            <a-select-option :value="41">出纳驳回</a-select-option>
            <!-- <a-select-option :value="42">已出账</a-select-option> -->
            <a-select-option :value="50">结算完成</a-select-option>
            <!-- <a-select-option :value="100">已作废</a-select-option> -->
          </a-select>
        </span>
        <!-- <span v-show="showIsSearch">
          <label>费用大类：</label>
          <a-select
            v-model="finance_type_id_pid"
            style="width: 120px"
            @change="selectedPID"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
          >
            <a-select-option
              v-show="item.name == '运营费用' || item.name == '管家工资'"
              v-for="item in parentsList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch && finance_type_id_pid != ''">
          <label>费用类型：</label>
          <a-select
            style="width: 120px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            v-model="finance_type_id"
          >
            <a-select-option
              v-for="item in costTypeList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>行业：</label>
          <a-select
            placeholder="请选择行业类型"
            style="width: 100px"
            v-model="trade_id"
          >
            <a-select-option
              v-for="(item, i) in tradeList"
              :key="i"
              :value="item.id"
              >{{ item.trade_name }}</a-select-option
            >
          </a-select>
        </span> -->
        <span v-show="showIsSearch">
          <label>一级项目：</label>
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="selectedOneVal"
            @change="selectedOne"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListOne"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="isShowTwo">
          <label>省级项目：</label>
          <a-select
            v-model="selectedTwoVal"
            @change="selectedTwo"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListTwo"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>项目：</label>
          <a-select
            v-model="selectedThreeVal"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListThree"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <!-- <span>
          <label>出账账户：</label>
          <a-select
            v-model="company_id"
            style="min-width: 160px"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in comList"
              :key="element.id"
              :value="element.id"
              >{{ element.company_name }}</a-select-option
            >
          </a-select>
        </span> -->
        <span v-show="showIsSearch">
          <a-select
            defaultValue="1"
            style="width: 100px; margin-right: 6px"
            v-model="time_type"
          >
            <a-select-option :value="1">费用所属日期</a-select-option>
            <a-select-option :value="4">出账日期</a-select-option>
          </a-select>
          <a-range-picker
            v-model="date"
            @change="changeDate"
            style="width: 220px"
            :placeholder="['开始时间', '结束时间']"
          />
        </span>
        <span>
          <label>字符串：</label>
          <a>
            <a-input
              v-model="query_field"
              style="width: 220px"
              placeholder="项目名称|报销编号|费用编号"
            />
          </a>
        </span>
        <span style="margin-right: 0">
          <a-button @click="onReset" style="margin-right: 10px">重置</a-button>
          <a-button
            style="margin-right: 10px"
            type="primary"
            icon="search"
            @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0">
              <td>合计</td>
              <td></td>
              <td></td>
              <td>{{ count_data.total_amount }}</td>
              <td>{{ count_data.out_total_amount }}</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data != ''" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.finance_type_name }}</td>
              <td>{{ item.finance_date.substring(0, 10) }}</td>
              <td>{{ item.amount }}</td>
              <td>
                <p v-show="item.status == 42 || item.status == 50">
                  {{ item.out_total_amount }}
                </p>
              </td>
              <!-- <td style="width: 26%">
                {{
                  item.detail.length > 36
                    ? item.detail.substring(0, 36) + "..."
                    : item.detail
                }}
              </td> -->
              <td>
                {{
                  item.detail.length > 20
                    ? item.detail.substring(0, 20) + "..."
                    : item.detail
                }}
              </td>
              <td>
                <p v-show="item.status == 10">待项目经理审核</p>
                <p v-show="item.status == 11">项目经理驳回</p>
                <p v-show="item.status == 20">待项目总监审核</p>
                <p v-show="item.status == 21">项目总监驳回</p>
                <p v-show="item.status == 30 && item.xf_status == 20">
                  待项目负责人审核
                </p>
                <p v-show="item.status == 30 && item.xf_status == 21">
                  项目负责人驳回
                </p>
                <p v-show="item.status == 30 && item.xf_status == 30">
                  待财务审核
                </p>
                <p v-show="item.status == 30 && item.xf_status == 31">
                  财务驳回
                </p>
                <p v-show="item.status == 30 && item.xf_status == 40">
                  待出纳审核
                </p>
                <p v-show="item.status == 30 && item.xf_status == 41">
                  出纳驳回
                </p>
                <p v-show="item.status == 30 && item.xf_status == 42">
                  部分打款
                </p>
                <p v-show="item.status == 30 && item.xf_status == 50">
                  结算完成
                </p>
                <p v-show="item.status == 30 && item.xf_status == 100">
                  费用作废
                </p>
              </td>
              <td>
                <!-- <a
                  v-show="
                    ((item.is_city == 1 && item.status == 20) ||
                      (item.is_province == 1 && item.status == 30) ||
                      (item.is_project == 1 && item.xf_status == 30) ||
                      item.status == 10 ||
                      item.status == 11 ||
                      item.status == 21 ||
                      item.xf_status == 21 ||
                      item.xf_status == 31 ||
                      item.xf_status == 41 ||
                      item.xf_status == 100) &&
                      item.xf_status != 50
                  "
                  style="margin-right:10px"
                  @click="editPage(item)"
                  >编辑</a
                > -->
                <a
                  v-show="
                    ((item.is_city == 1 && item.status == 20) ||
                      (item.is_province == 1 && item.status == 30) ||
                      (item.is_project == 1 && item.xf_status == 30) ||
                      item.status == 10 ||
                      item.status == 11 ||
                      item.status == 21 ||
                      item.xf_status == 21 ||
                      item.xf_status == 31 ||
                      item.xf_status == 41 ||
                      item.xf_status == 100) &&
                      item.xf_status != 50
                  "
                  style="color: #F56C6C;margin-right:10px"
                  @click="deletePage(item.id)"
                  >删除</a
                >
                <a style="color: #909399" @click="detailsPage(item)">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 详情/ -->
    <expenseDetails v-show="isShowDetails" :detailsVal="detailsVal" />
    <!-- 详情 end -->
    <!-- 新增报销 -->
    <addExpense v-show="showIsAdd" v-on:hideInAdd="hideInAdd" />
    <!-- 新增报销 end -->
    <!-- 编辑 -->
    <expenseEdit
      v-show="showIsEdit"
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 编辑 end -->
  </div>
</template>
<script>
import axios from "axios";
import expenseDetails from "@/components/money/expenseDetails";
import addExpense from "@/components/money/addExpense";
import expenseEdit from "@/components/money/expenseEdit";
import { mapState } from "vuex";

export default {
  components: {
    expenseDetails,
    addExpense,
    expenseEdit
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      totalPage: Number,
      thList: [
        "项目",
        "类型",
        "费用所属日期",
        "报销金额",
        "打款金额",
        "费用明细",
        "状态",
        "详情"
      ],
      type: "",
      proList: [],
      project_id: "",
      company_id: "",
      customer_id: "",
      comList: [],
      customerList: [],
      time_type: 1,
      date: null,
      start_date: "",
      end_date: "",
      query_field: "",
      costList: [],
      isShowPrint: false,
      status: "",
      showIsLoading: false,
      detailsVal: {},
      isShowDetails: false,
      count_data: "",
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      showIsSearch: false,
      costTypeList: [],
      parentsList: [],
      finance_type_id_pid: "",
      finance_type_id: "",
      tradeList: [],
      trade_id: "",
      showIsAdd: false,
      showIsEdit: false,
      editDetail: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getCompany(); //获取公司
    this.getCustomer(); //获取客户
    this.getProOne(); //获取一级项目列表
    this.getPro(); //获取项目
    this.getParents(); //获取费用大类
    this.getType(-1); //获取费用类型
    this.getTrade(); //获取行业
  },
  watch: {},
  methods: {
    deletePage(id) {
      let _this = this;
      this.$confirm({
        title: "提示",
        content: "确定要删除",
        okText: "确认",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          _this.deleteExpense(id);
          console.log("OK");
        }
      });
    },
    deleteExpense(id) {
      // console.log(id);
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Reimbursement/delete";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        id: id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.reload();
          this.$message.success("删除成功");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    hideInEdit(msg) {
      this.showIsEdit = false;
      if (msg) {
        this.reload();
      }
    },
    editPage(item) {
      this.editDetail = item;
      this.showIsEdit = true;
    },
    hideInAdd(msg) {
      this.showIsAdd = false;
      if (msg) {
        this.reload();
      }
    },
    getTrade() {
      let url = this.httpsBasic.url + this.httpsBasic.trade + "Trade/tradeList";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        current_page: 1,
        per_page: 1000
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.tradeList = res.data.data.data;
        }
      });
    },
    getParents() {
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/getLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: 0
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.parentsList = res.data.data;
        }
      });
    },
    selectedPID(id) {
      this.finance_type_id = "";
      this.getType(id); //获取费用类型
    },
    getType(id) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance_type/getTwoLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.costTypeList = res.data.data;
        }
      });
    },
    selectedOne(id) {
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.getProID(id, 1); //获取下级项目
    },
    selectedTwo(id) {
      this.selectedThreeVal = "";
      this.getProID(id, 2); //获取下级项目
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "contract/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    detailsPage(item) {
      this.isShowDetails = true;
      this.detailsVal = item;
    },
    showInUserList() {
      this.isShowDetails = false;
      this.showIsAdd = false;
      this.showIsEdit = false;
    },
    doPrint() {
      let prnHtml = document.getElementById("printData").innerHTML; //需要打印的内容
      const newWin = window.open(""); // 新打开一个空窗口
      newWin.document.body.innerHTML = prnHtml; //把需要打印的内容插入新窗口
      newWin.document.close(); //关闭文档输入流（window.close()和document.close()的区别）
      newWin.focus();

      setTimeout(() => {
        //定时器等待，JS单线程，异步执行此行代码
        newWin.print();
        newWin.close(); //打印完成或取消，关闭新窗口
      }, 200);
    },
    changeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    getCompany() {
      let url =
        this.httpsBasic.url + this.httpsBasic.customer + "Company/companyList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.comList = res.data.data.data;
            // console.log(this.comList);
          }
        });
    },
    getCustomer() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Third_part/thirdPartList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.customerList = res.data.data.data;
          }
        });
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      let status = "",
        xf_status = "";
      if (
        this.status == 10 ||
        this.status == 11 ||
        this.status == 200 ||
        this.status == 201
      ) {
        xf_status = "";
        switch (this.status) {
          case 10:
            status = this.status;
            break;
          case 11:
            status = this.status;
            break;
          case 200:
            status = 20;
            break;
          case 201:
            status = 21;
            break;
        }
      } else {
        status = "";
        xf_status = this.status;
      }
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/myReimbursement";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          time_type: this.end_date == "" ? 0 : this.time_type,
          start_date: this.start_date,
          end_date: this.end_date,
          status: status,
          xf_status: xf_status,
          project_id: pro,
          trade_id: this.trade_id,
          finance_type_id: this.finance_type_id,
          finance_type_id_pid: this.finance_type_id_pid,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.count_data = res.data.data.count_data;
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    onReset() {
      this.date = null;
      this.project_id = "";
      this.company_id = "";
      this.customer_id = "";
      this.time_type = 1;
      this.start_date = "";
      this.end_date = "";
      this.query_field = "";
      this.selectedOneVal = "";
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.proListTwo = [];
      this.proListThree = [];
      this.isShowTwo = false;
      this.status = "";
      this.trade_id = "";
      this.finance_type_id = "";
      this.finance_type_id_pid = "";
      this.getPro();
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .example {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 100px;
    height: 100px;
  }
  .searchBox {
    padding: 14px 2%;
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
    }
  }
  .printData {
    table {
      width: 100%;
      td,
      th {
        border: 1px solid #ccc;
        padding: 4px 6px;
        font-size: 14px;
      }
      th {
        background: #fafafa;
      }
    }
    .total {
      text-align: right;
      margin-top: 30px;
      margin-right: 14px;
      p {
        font-size: 16px;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
